export default __webpack_public_path__ + "bceb99b0203af8658485ac7ae89a66c8.png";